import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Hairline, RubberStamp } from "@/components/primitives";
import { MobileFrame } from "@/components/MobileFrame";

export default function Posted() {
  const nav = useNavigate();
  const [platform, setPlatform] = useState("Depop");
  const [price, setPrice] = useState("98.00");
  const [scanId, setScanId] = useState<string | null>(null);

  useEffect(() => {
    setPlatform(sessionStorage.getItem("fig_last_post_platform") || "Depop");
    setPrice(sessionStorage.getItem("fig_last_post_price") || "98");
    setScanId(sessionStorage.getItem("fig_current_scan_id"));
  }, []);

  const listingId = scanId ? `FIG-${scanId.slice(0, 8).toUpperCase()}` : "FIG-00241-D";

  return (
    <MobileFrame>
      <div className="paper-bg" style={{ minHeight: "100vh", padding: "120px 28px 40px", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <RubberStamp label="POSTED" sub={`TO ${platform.toUpperCase()}`} color="hsl(var(--olive))" size={170} />
        <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontWeight: 800, fontSize: 34, color: "hsl(var(--ink))", letterSpacing: "-0.02em", lineHeight: 1, marginTop: 32, textAlign: "center" }}>
          Out into the world.
        </div>
        <div style={{ fontFamily: "'Fraunces', 'Playfair Display', serif", fontSize: 16, color: "hsl(var(--ink-2))", marginTop: 8, textAlign: "center", maxWidth: 280 }}>
          Your listing is live. We'll ping you the moment it moves.
        </div>
        <Hairline dashed style={{ width: "100%", margin: "28px 0" }} />
        <div style={{ width: "100%", fontFamily: "'IBM Plex Mono', monospace", fontSize: 11, color: "hsl(var(--ink-2))", lineHeight: 1.6 }}>
          {[
            ["listing id", listingId],
            ["platform", platform.toLowerCase()],
            ["price", `$${Number(price).toFixed(2)}`],
            ["expected close", "5–8 days"],
          ].map(([k, v]) => (
            <div key={k} style={{ display: "flex", justifyContent: "space-between" }}>
              <span>{k}</span><span>{v}</span>
            </div>
          ))}
        </div>
        <button className="btn btn-primary" style={{ width: "100%", padding: "16px", marginTop: "auto" }} onClick={() => nav("/home")}>
          Back to the closet
        </button>
      </div>
    </MobileFrame>
  );
}
